import React, { ReactNode, SVGProps } from 'react';
import { themes } from 'styles/themes/wikifactoryNew';

const defaultDivider = (
  <div className='flex-shrink-0 h-[32px] border-r border-wfGrey100' />
);

export const insertDivider = (
  elements: ReactNode[],
  options?: {
    divider?: ReactNode;
    fromFirst?: boolean;
    regardlessLength?: boolean;
  },
) => {
  const {
    divider = defaultDivider,
    fromFirst,
    regardlessLength,
  } = options || {};

  return elements.filter(Boolean).map((element, index, list) => {
    const elementsLen = list.length;
    const isFirst = index === 0;
    const isLast = index === list.length - 1;
    const renderDividerForFirst = regardlessLength || elementsLen > 1;

    let keyProp: any = {};
    if (element.key) keyProp = { key: element.key };

    // TODO: This is wrong, should print a warning so elements are not missing a key.
    const defaultKey = `${index}`;
    return (
      <React.Fragment key={defaultKey} {...keyProp}>
        {fromFirst && isFirst && renderDividerForFirst && divider}
        {element}
        {isLast ? null : divider}
      </React.Fragment>
    );
  });
};

export const renderCustomIcon = (
  IconElement: (props: SVGProps<SVGSVGElement>) => JSX.Element,
  {
    isHover,
    isActive,
    isDisabled,
    activeFillColor = themes.color.wfWhite,
    hoverFillColor = themes.color.wfBlack,
    disabledFillColor = themes.color.wfGrey350,
    defaultFillColor = themes.color.wfBlack,
  }: {
    isHover: boolean;
    isActive?: boolean;
    isDisabled?: boolean;
    activeFillColor?: string;
    disabledFillColor?: string;
    hoverFillColor?: string;
    defaultFillColor?: string;
  },
) => {
  if (isHover) {
    const hoverColor = isDisabled ? disabledFillColor : hoverFillColor;

    return <IconElement fill={isHover ? hoverColor : defaultFillColor} />;
  }

  if (isActive) {
    return <IconElement fill={activeFillColor} />;
  }

  return <IconElement fill={defaultFillColor} />;
};
